





import React, { useState } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaWhatsapp, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

import { FaPinterest } from "react-icons/fa";
import { RiThreadsFill } from "react-icons/ri";
const THEME = {
  primary: "#1774BA",
  primaryDark: "#1774BA",
  accent: "#1774BA",
  ink: "#0e1522",
  white: "#ffffff",
};

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <header
      className="aaryan-header"
      style={{
        "--pri": THEME.primary,
        "--priD": THEME.primaryDark,
        "--acc": THEME.accent,
        "--ink": THEME.ink,
        "--w": THEME.white,
      }}
    >
      {/* 🌐 TOP CONTACT BAR */}
      <div className="ah-top">
        <div className="container d-flex flex-wrap justify-content-center justify-content-xl-between gap-3">

          {/* CONTACTS */}
          <ul className="ah-contacts m-0 p-0 d-flex flex-wrap gap-4 text-white">
            <li>
              
              <a href="tel:+919730707888" className="text-white">
                <i className="fa-solid fa-phone text-white" /> +91 9730707888
              </a>
            </li>

            <li>
              <a href="tel:+919833377051" className="text-white">
                <i className="fa-solid fa-phone-volume text-white" /> +91 9833377051
              </a>
            </li>

            <li>
              <a href="mailto:bookings@aaryantravels.com" className="text-white ">
                <i className="fa-regular fa-envelope text-white" /> bookings@aaryantravels.com
              </a>
            </li>
          </ul>

       
<ul className="ah-social m-0 p-0 d-flex align-items-center gap-3">
  <li>
    <a href="https://www.facebook.com/aaryantravels15/" target="_blank" rel="noopener noreferrer">
      <FaFacebookF />
    </a>
  </li>

  {/* <li>
    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
      <FaTwitter />
    </a>
  </li> */}

  <li>
    <a href="https://wa.me/919730707888" target="_blank" rel="noopener noreferrer">
      <FaWhatsapp />
    </a>
  </li>

  <li>
    <a href="https://www.instagram.com/aaryan__travels/" target="_blank" rel="noopener noreferrer">
      <FaInstagram />
    </a>
  </li>

  <li>
    <a href="https://www.linkedin.com/company/108839473/" target="_blank" rel="noopener noreferrer">
      <FaLinkedinIn />
    </a>
  </li>

  <li>
    <a href="https://www.youtube.com/@aaryantravels" target="_blank" rel="noopener noreferrer">
      <FaYoutube />
    </a>
  </li>

  <li>
  <a
    href="https://www.threads.com/@aaryan__travels"
    target="_blank"
    rel="noopener noreferrer"
  >
    <RiThreadsFill />
  </a>
</li>

<li>
  <a
    href="https://in.pinterest.com/Aaryan__travels/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaPinterest />
  </a>
</li>
</ul>



        </div>
      </div>

      {/* MAIN NAVIGATION */}
      <div className="ah-nav-wrap bg-">
        <Navbar expand="lg" className="ah-bar" sticky="top">
          <Container>
            {/* LOGO */}
            <Link to="/" className="d-flex align-items-center gap-2 text-decoration-none">
              <img src="/images/9.png" alt="Aaryan Travels" className="ah-logo" />
            </Link>

            {/* MOBILE MENU TOGGLE */}
            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fa-solid fa-bars darkcolor"></i>
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
              <Nav className="mx-auto ah-links">

                <Nav.Link as={Link} to="/" className="fw-bold nav-item">Home</Nav.Link>

                <NavDropdown title="About Us" id="about-us-dropdown" className="fw-bold ">
                  <NavDropdown.Item as={Link} to="/about">About Us</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/term-condition">Term & Condition</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/privacy-policy">Privacy Policy</NavDropdown.Item>
                </NavDropdown>

                <Nav.Link as={Link} to="/our-network" className="fw-bold nav-item ">Our&nbsp;Network</Nav.Link>
                <Nav.Link as={Link} to="/services" className="fw-bold nav-item ">Services</Nav.Link>

                <NavDropdown title="Rides" id="rides-dropdown" className="fw-bold ">
                  <NavDropdown.Item href="/sedan">Sedan</NavDropdown.Item>
                  <NavDropdown.Item href="/muv">MUV</NavDropdown.Item>
                  <NavDropdown.Item href="/premium">Premium</NavDropdown.Item>
                  <NavDropdown.Item href="/luxury">Luxury</NavDropdown.Item>
                  <NavDropdown.Item href="/buses">Buses</NavDropdown.Item>
                  <NavDropdown.Item href="/E-Vehical">E-Vehical</NavDropdown.Item>
                </NavDropdown>

                <Nav.Link as={Link} to="/gallery" className="fw-bold nav-item ">Gallery</Nav.Link>
                <Nav.Link as={Link} to="/blogs" className="fw-bold nav-item ">Blog</Nav.Link>

                <NavDropdown title="Contact Us" id="contact-dropdown" className="fw-bold ">
                  <NavDropdown.Item as={Link} to="/contact-us">Contact Us</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/enquiry">Enquiry</NavDropdown.Item>
                </NavDropdown>

                {/* ONLINE BOOKING BUTTON */}
                <Nav.Item>
                  <button
                    onClick={() =>
                      window.open(
                        "https://wa.me/919730707888?text=Hello%20Aaryan%20Travels%2C%20I%20want%20to%20book%20a%20corporate%20cab.%20Please%20assist%20me.",
                        "_blank"
                      )
                    }
                    className="aaryan-header-btn px-3 py-2 mt-md-2"
                    style={{
                      backgroundColor: "#1774BA",
                      color: "white",
                      borderRadius: "8px",
                      fontWeight: "600",
                      border: "none",
                    }}
                  >
                    Online Booking
                  </button>
                </Nav.Item>

              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </header>
  );
};

export default Header;
